import { gql } from '@apollo/client';
const UPDATE_PRODUCT_VARIANT_SNAPSHOT_COST = gql `
  mutation UpdateProductVariantSnapshotCost(
    $productVariantSnapshotId: ID!
    $currencyId: ID
    $price: Float
  ) {
    updateProductVariantSnapshotCost(
      productVariantSnapshotId: $productVariantSnapshotId
      currencyId: $currencyId
      price: $price
    ) {
      productVariantSnapshot {
        id
        currency {
          id
          isoCode
        }
        price
        productVariant {
          id
          currentPrice {
            id
            price
            currency {
              id
              isoCode
            }
          }
        }
        productVariant {
          id
          priceHistory {
            edges {
              node {
                id
                price
                currency {
                  id
                  isoCode
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default UPDATE_PRODUCT_VARIANT_SNAPSHOT_COST;
